import { React, useState, useEffect } from "react";
import { getMeta, ImgIcons } from "../../Helpers/Common";
import { Helmet } from "react-helmet";
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));

export function Metadata(props) {
  const { page } = props;
  const [metadata, setmetadata] = useState(0);
  const getMetddda = () => {
    getMeta(props.page, props.name, props.contentdetails).then((responsedata) => {
      setmetadata(responsedata)
    })
  }
  useEffect(() => {
    getMetddda();
  }, [page]);

  return (
    <Helmet>
      {props.name ? (<title>{metadata['title']}</title>) : (<title>{metadata['title']}</title>)}
      {/* {props.contentdetails.description ? (<meta property="og:description" content={metadata['description']} />) : (<meta property="og:description" content={metadata['description']} />)} */}
      <meta property="og:title" content={metadata['title']} />
      <meta property="og:description" content={metadata['description']} />
      {/* <meta property="og:image" content={props.contentdetails.thumbnail_image2.small} /> */}
      {/* <meta property="og:url" content={window.location.href} /> */}
      {/* <meta property="og:type" content="website" />
      <meta name="twitter:url" content={metadata['url']} />
      <meta name="twitter:title" content="" />
      <meta name="twitter:description" content={metadata['description']} />
      <meta name="twitter:image" content="" />
      <link rel="canonical" content="" /> */}
    </Helmet>
  );
}

export default Metadata;
